import { create } from 'zustand';
import { createPricingRulesSlice } from './pricing-rules-slice';
import { createImporterSlice } from './importer-store-slice';
import { createViewSlice } from './view-store-slice';
import { createBannersSlice } from './banners-slice';
import type { CombinedStore } from './types';

export const useBoundStore = create<CombinedStore>((...args) => ({
	...createPricingRulesSlice(...args),
	...createImporterSlice(...args),
	...createViewSlice(...args),
	...createBannersSlice(...args),
}));
